import Clean from './Clean/Clean';

const templates = {
  Clean,
};

export default templates;
